export const DEFAULT_IMAGE_URL =
  "https://karsten-swagger-api-docs.s3.amazonaws.com/ProdutoSemImagem.png";

export function isDefaultCatalogProductImage(url) {
  return url?.split("/").pop() === "ProdutoSemImagem.png";
}

export function handleCatalogImageLoadError(event) {
  const img = event.currentTarget;
  if (!img || isDefaultCatalogProductImage(img.src)) return;
  img.onerror = null;
  img.src = DEFAULT_IMAGE_URL;
}
